/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 248:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(123);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(124);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }







var featureLoader = function featureLoader(name, version) {
  return new Promise(function (resolve, reject) {
    window.Shopify.loadFeatures([{
      name: name,
      version: version,
      onLoad: resolve()
    }], function (error) {
      if (error) reject(error);
    });
  });
};

var modelViewerLoader = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(modelViewerVersion, modelsData) {
    var _window$ShopifyXR2, initModels, waitForShopifyXR;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return new Promise(function (resolve, reject) {
              Promise.all([featureLoader('model-viewer', modelViewerVersion), featureLoader('shopify-xr', '1.0')]).then(resolve())["catch"](reject());
            });

          case 3:
            initModels = function initModels() {
              window.ShopifyXR.addModels(modelsData);
              window.ShopifyXR.setupXRElements();
            };

            waitForShopifyXR = function waitForShopifyXR() {
              var _window$ShopifyXR;

              if ((_window$ShopifyXR = window.ShopifyXR) !== null && _window$ShopifyXR !== void 0 && _window$ShopifyXR.addModels) return initModels();
              requestAnimationFrame(waitForShopifyXR);
            };

            if ((_window$ShopifyXR2 = window.ShopifyXR) !== null && _window$ShopifyXR2 !== void 0 && _window$ShopifyXR2.addModels) {
              initModels();
            } else {
              document.addEventListener('shopify_xr_initialized', waitForShopifyXR);
            }

            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", window.console.error('Error loading model viewer scripts', _context.t0));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function modelViewerLoader(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (modelViewerLoader);

/***/ }),

/***/ 178:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(179);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);


var qtySelector = function qtySelector(decrementBtn, incrementBtn, input) {
  if (!decrementBtn || !incrementBtn || !input) return;
  var inputMin = Number(input.getAttribute('min'));
  decrementBtn.addEventListener('click', function () {
    var newQty = Number(input.value) - 1;

    if (newQty <= 0) {
      return;
    }

    input.value = Number(newQty);
    input.dispatchEvent(new Event('change'));

    if (newQty <= inputMin) {
      decrementBtn.setAttribute('disabled', '');
    }
  });
  incrementBtn.addEventListener('click', function () {
    var newQty = Number(input.value) + 1;
    input.value = Number(newQty);
    input.dispatchEvent(new Event('change'));

    if (newQty > inputMin) {
      decrementBtn.removeAttribute('disabled');
    }
  });
  input.addEventListener('input', function () {
    if (input.value <= inputMin) {
      decrementBtn.setAttribute('disabled', '');
    } else {
      decrementBtn.removeAttribute('disabled');
    }
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (qtySelector);

/***/ }),

/***/ 242:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(191);
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(132);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(135);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(177);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(230);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(231);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(142);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(146);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(123);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(44);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(124);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(184);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(243);
/* harmony import */ var _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(244);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(2);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(153);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(172);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var flickity_as_nav_for__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(247);
/* harmony import */ var flickity_as_nav_for__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(flickity_as_nav_for__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _components_qty_selector__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(178);
/* harmony import */ var _components_model_viewer_loader__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(248);
/* harmony import */ var _utils_play_pause__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(249);
/* harmony import */ var _utils_pricing__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(251);
/* harmony import */ var _svg_icon_success_svg__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(255);
/* harmony import */ var _svg_icon_alert_svg__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(256);
var _window$Shopify, _window$Shopify$theme, _window$Shopify$theme2;
































var selectors = {
  addToCart: '[data-add-to-cart]',
  comparePrice: '[data-product-compare-at-price]',
  priceWrapper: '[data-price-wrapper]',
  productForm: '[data-product-form]',
  inventoryJson: '[data-product-inventory-json]',
  modelsJson: '[data-product-models-json]',
  productImageWrapper: '[data-product-image-wrapper]',
  productVideoWrapper: '[data-product-video-wrapper]',
  productPrice: '[data-product-price]',
  productSku: '[data-product-sku]',
  productInventory: '[data-product-inventory]',
  productDescriptionMoreLink: '[data-product-description-more-link]',
  productDescriptionMoreContent: '[data-product-description-more-content]',
  decrementQtyBtn: '[data-decrement-qty]',
  incrementQtyBtn: '[data-increment-qty]',
  qtyInput: '[data-qty-input]',
  reviewsSlider: '[data-product-reviews-slider]',
  addedLabel: '.product-card__added'
};
var cssClasses = {
  hide: 'hide',
  onsale: 'product__price-container--on-sale',
  show: 'show'
};
var sectionType = 'main-product';
var registeredSections = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : (_window$Shopify$theme = _window$Shopify.theme) === null || _window$Shopify$theme === void 0 ? void 0 : (_window$Shopify$theme2 = _window$Shopify$theme.sections) === null || _window$Shopify$theme2 === void 0 ? void 0 : _window$Shopify$theme2.registered) || {};
var isUnregistered = typeof registeredSections[sectionType] === 'undefined';
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isUnregistered && (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_21__.register)(sectionType, {
  onLoad: function onLoad() {
    // Register the product form using @shopify/theme-product-form
    var formElement = this.container.querySelector(selectors.productForm);
    var productJSON = window.productJSON;
    var options = {
      onOptionChange: this.onOptionChange.bind(this),
      onFormSubmit: this.onFormSubmit.bind(this),
      // theme-product-form requires callbacks to be passed
      // for all four form events.
      onPropertyChange: function onPropertyChange() {
        return true;
      }
    };

    if (formElement && productJSON) {
      this.productForm = new _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_20__.ProductForm(formElement, productJSON, options);
    } // Setup inventory data passed through from liquid


    var inventoryJson = this.container.querySelector(selectors.inventoryJson);

    if (inventoryJson) {
      this.productInventories = JSON.parse(inventoryJson.innerHTML || '{}');
    } // Parse the settings string passed through from liquid


    var settingsData = this.container.dataset.sectionSettings || '{}';
    this.sectionSettings = JSON.parse(settingsData); // If URL contains ?variant= param, get the selected variant ID

    var selectedVariant = this.container.dataset.selectedVariant;
    this.slideShowDesktop = this.container.querySelector('.product__media.desktop .product__slideshow');
    this.sliderDesktop = null;

    if (this.slideShowDesktop) {
      var container = this.container;
      var slideshow = this.slideShowDesktop;
      var settings = this.sectionSettings;
      var updateFeaturedImage = this.updateFeaturedImage.bind(this);
      this.sliderDesktop = new (flickity__WEBPACK_IMPORTED_MODULE_22___default())(slideshow, {
        draggable: '>1',
        prevNextButtons: false,
        pageDots: settings.include_pager_dots,
        watchCSS: true,
        wrapAround: settings.infinite,
        fullscreen: false,
        on: {
          ready: function ready() {
            var _this$previousButton,
                _this = this,
                _this$nextButton;

            // If enabled, connect slider previous/next buttons
            this.previousButton = container.querySelectorAll('.controls-container--main .btn--control-prev')[1];
            this.nextButton = container.querySelectorAll('.controls-container--main .btn--control-next')[1];
            (_this$previousButton = this.previousButton) === null || _this$previousButton === void 0 ? void 0 : _this$previousButton.addEventListener('click', function () {
              return _this.previous(settings.infinite, false);
            });
            (_this$nextButton = this.nextButton) === null || _this$nextButton === void 0 ? void 0 : _this$nextButton.addEventListener('click', function () {
              return _this.next(settings.infinite, false);
            });

            if (this.previousButton) {
              this.previousButton.disabled = !settings.infinite && this.selectedIndex === 0;
            }

            if (this.nextButton) {
              this.nextButton.disabled = !settings.infinite && this.selectedIndex === this.slides.length - 1;
            }

            var modelViewers = this.sliderDesktop && this.sliderDesktop.querySelectorAll('model-viewer');

            if (modelViewers && modelViewers.length > 0) {
              var _container$querySelec;

              var modelViewerVersion = modelViewers[0].dataset.version;
              var modelsData = (_container$querySelec = container.querySelector(selectors.modelsJson)) === null || _container$querySelec === void 0 ? void 0 : _container$querySelec.textContent;

              if (modelViewerVersion && modelsData) {
                var modelsDataJson = JSON.parse(modelsData);
                (0,_components_model_viewer_loader__WEBPACK_IMPORTED_MODULE_26__.default)(modelViewerVersion, modelsDataJson).then(function () {
                  return null;
                })["catch"](function () {
                  return null;
                });
              } // Stop slider drag events from impacting 3D model interaction


              var modelStopPropagation = function modelStopPropagation(event) {
                return event.stopPropagation();
              };

              modelViewers.forEach(function (modelViewer) {
                modelViewer.addEventListener('mousedown', modelStopPropagation);
                modelViewer.addEventListener('touchstart', modelStopPropagation);
                modelViewer.addEventListener('pointerdown', modelStopPropagation);
              });
            } // Select the slider image matching the current variant


            updateFeaturedImage(selectedVariant ? selectedVariant : null, this);
          },
          change: function change(index) {
            if (this.previousButton) {
              this.previousButton.disabled = !settings.infinite && index === 0;
            }

            if (this.nextButton) {
              this.nextButton.disabled = !settings.infinite && index === this.slides.length - 1;
            }

            var videoMediaWrappers = this.sliderDesktop && this.sliderDesktop.querySelectorAll(selectors.productVideoWrapper);
            videoMediaWrappers && videoMediaWrappers.forEach(function (wrapper) {
              if (wrapper.dataset.mediaType === 'video') {
                var video = wrapper.querySelector('video');
                video.pause();
              } else {
                var iframe = wrapper.querySelector('iframe');
                (0,_utils_play_pause__WEBPACK_IMPORTED_MODULE_27__.playPause)(iframe, 'pause');
              }
            });
          }
        }
      });
    } // Look for a product image slideshow.


    this.slideShowMobile = this.container.querySelector('.product__media.mobile .product__slideshow'); // Initialise the slider

    this.sliderMobile = null;

    if (this.slideShowMobile) {
      var _container = this.container;
      var _slideshow = this.slideShowMobile;
      var _settings = this.sectionSettings;

      var _updateFeaturedImage = this.updateFeaturedImage.bind(this);

      this.sliderMobile = new (flickity__WEBPACK_IMPORTED_MODULE_22___default())(_slideshow, {
        draggable: '>1',
        prevNextButtons: false,
        pageDots: _settings.include_pager_dots,
        watchCSS: true,
        wrapAround: _settings.infinite,
        fullscreen: false,
        on: {
          ready: function ready() {
            var _this$previousButton2,
                _this2 = this,
                _this$nextButton2;

            // If enabled, connect slider previous/next buttons
            this.previousButton = _container.querySelectorAll('.controls-container--main .btn--control-prev')[0];
            this.nextButton = _container.querySelectorAll('.controls-container--main .btn--control-next')[0];
            (_this$previousButton2 = this.previousButton) === null || _this$previousButton2 === void 0 ? void 0 : _this$previousButton2.addEventListener('click', function () {
              return _this2.previous(_settings.infinite, false);
            });
            (_this$nextButton2 = this.nextButton) === null || _this$nextButton2 === void 0 ? void 0 : _this$nextButton2.addEventListener('click', function () {
              return _this2.next(_settings.infinite, false);
            });

            if (this.previousButton) {
              this.previousButton.disabled = !_settings.infinite && this.selectedIndex === 0;
            }

            if (this.nextButton) {
              this.nextButton.disabled = !_settings.infinite && this.selectedIndex === this.slides.length - 1;
            }

            var modelViewers = this.sliderMobile && this.sliderMobile.querySelectorAll('model-viewer');

            if (modelViewers && modelViewers.length > 0) {
              var _container$querySelec2;

              var modelViewerVersion = modelViewers[0].dataset.version;
              var modelsData = (_container$querySelec2 = _container.querySelector(selectors.modelsJson)) === null || _container$querySelec2 === void 0 ? void 0 : _container$querySelec2.textContent;

              if (modelViewerVersion && modelsData) {
                var modelsDataJson = JSON.parse(modelsData);
                (0,_components_model_viewer_loader__WEBPACK_IMPORTED_MODULE_26__.default)(modelViewerVersion, modelsDataJson).then(function () {
                  return null;
                })["catch"](function () {
                  return null;
                });
              } // Stop slider drag events from impacting 3D model interaction


              var modelStopPropagation = function modelStopPropagation(event) {
                return event.stopPropagation();
              };

              modelViewers.forEach(function (modelViewer) {
                modelViewer.addEventListener('mousedown', modelStopPropagation);
                modelViewer.addEventListener('touchstart', modelStopPropagation);
                modelViewer.addEventListener('pointerdown', modelStopPropagation);
              });
            } // Select the slider image matching the current variant


            _updateFeaturedImage(selectedVariant ? selectedVariant : null, this);
          },
          change: function change(index) {
            if (this.previousButton) {
              this.previousButton.disabled = !_settings.infinite && index === 0;
            }

            if (this.nextButton) {
              this.nextButton.disabled = !_settings.infinite && index === this.slides.length - 1;
            }

            var videoMediaWrappers = this.sliderMobile && this.sliderMobile.querySelectorAll(selectors.productVideoWrapper);
            videoMediaWrappers.forEach(function (wrapper) {
              if (wrapper.dataset.mediaType === 'video') {
                var video = wrapper.querySelector('video');
                video.pause();
              } else {
                var iframe = wrapper.querySelector('iframe');
                (0,_utils_play_pause__WEBPACK_IMPORTED_MODULE_27__.playPause)(iframe, 'pause');
              }
            });
          }
        }
      });
    }

    (0,_components_qty_selector__WEBPACK_IMPORTED_MODULE_25__.default)(this.container.querySelector(selectors.decrementQtyBtn), this.container.querySelector(selectors.incrementQtyBtn), this.container.querySelector(selectors.qtyInput));
    this.initProductDescriptionMore();
    this.initReviewsSlider();
    this.handleDownloadClick();
  },
  // Event callback for option/variant switch event
  onOptionChange: function onOptionChange(event) {
    var variant = event.dataset.variant;
    /* eslint-disable no-negated-condition */

    if (!variant) {
      // The combination of selected options does not have a matching variant
      this.updateAddToCartState(null);
      this.updateProductPrices(false);
      this.updateFeaturedImage(false);
      this.updateProductSku(variant);
      this.updateProductInventory(variant);
    } else if (!variant.available) {
      // The combination of selected options has a matching variant but it is
      // currently unavailable
      this.updateAddToCartState(false);
      this.updateProductPrices(true, variant.price, variant.compare_at_price);
      this.updateFeaturedImage(variant.id);
      this.updateProductSku(variant);
      this.updateProductInventory(variant);
      var url = (0,_shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_20__.getUrlWithVariant)(window.location.href, variant.id);
      window.history.replaceState({
        path: url
      }, '', url);
    } else {
      // The combination of selected options has a matching variant and it is
      // available
      this.updateAddToCartState(true);
      this.updateProductPrices(true, variant.price, variant.compare_at_price);
      this.updateFeaturedImage(variant.id);
      this.updateProductSku(variant);
      this.updateProductInventory(variant);

      var _url = (0,_shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_20__.getUrlWithVariant)(window.location.href, variant.id);

      window.history.replaceState({
        path: _url
      }, '', _url);
    }
    /* eslint-enable no-negated-condition */

  },
  // Event callback for Theme Editor `section:unload` event
  onUnload: function onUnload() {
    if (this.productForm) {
      this.productForm.destroy();
    }
  },
  // Event callback for product form submit event
  onFormSubmit: function onFormSubmit(event) {
    event.preventDefault();
    var _event$dataset = event.dataset,
        variant = _event$dataset.variant,
        quantity = _event$dataset.quantity,
        properties = _event$dataset.properties;
    if (!variant || !variant.id || !quantity) return;

    var pouringCheckbox = this.container.querySelector('[data-pouring-checkbox]');
    if (this.container.querySelector('[data-pouring-discount]')) {
      properties = Object.assign({}, properties || {}, {_pouring_eligible: 'true'});
    }

    if (pouringCheckbox && pouringCheckbox.checked) {
      properties = Object.assign({}, properties || {}, {_pouring: 'true'});
    }

    if (
      window.BibendumPricing &&
      typeof window.BibendumPricing.withCompareAtProperty === 'function' &&
      variant.compare_at_price
    ) {
      properties = window.BibendumPricing.withCompareAtProperty(
        properties,
        variant.compare_at_price,
      );
    }

    var item = {
      id: variant.id,
      quantity: quantity
    };

    if (properties) {
      item.properties = properties;
    }

    var addedLabel = this.container.querySelector(selectors.addedLabel);

    if (addedLabel) {
      window.sideCart.handleAddToCartEvent(item, false);
      addedLabel === null || addedLabel === void 0 ? void 0 : addedLabel.classList.add(cssClasses.show);
      setTimeout(function () {
        addedLabel === null || addedLabel === void 0 ? void 0 : addedLabel.classList.remove(cssClasses.show);
      }, 2000);
    } else {
      window.sideCart.handleAddToCartEvent(item, true);
    }
  },

  /**
   * Updates the DOM state of the add to cart button
   *
   * @param {boolean} enabledState - True is enabled. False is disabled. Null is disabled without prices.
   * @param {string} priceWrapper - DOM selector for prices container div
   * @param {string} button - DOM selector for add to cart button
   */
  updateAddToCartState: function updateAddToCartState(enabledState) {
    var addToCartBtn = this.container.querySelector(selectors.addToCart);
    var priceWrapper = this.container.querySelector(selectors.priceWrapper);

    switch (enabledState) {
      // Variant is available
      case true:
        {
          priceWrapper.classList.remove(cssClasses.hide);
          addToCartBtn.removeAttribute('disabled');
          addToCartBtn.textContent = theme.strings.addToCart;
          break;
        }
      // Variant is unavailable

      case false:
        {
          priceWrapper.classList.remove(cssClasses.hide);
          addToCartBtn.setAttribute('disabled', '');
          addToCartBtn.textContent = theme.strings.soldOut;
          break;
        }
      // No matching variant

      case null:
        {
          priceWrapper.classList.add(cssClasses.hide);
          addToCartBtn.setAttribute('disabled', '');
          addToCartBtn.textContent = theme.strings.unavailable;
          break;
        }
    }
  },

  /**
   * Updates the DOM with specified prices
   *
   * @param {boolean} variantExists - Selected options match a valid variant
   * @param {number} price - Selected variant price
   * @param {number} compareAtPrice - Selected variant original price
   * @param {string} productPrice - DOM selector for current price of the product
   * @param {string} comparePrice - DOM selector for original price of the product
   * @param {string} priceWrapper - DOM selector for prices container div
   */
  updateProductPrices: function updateProductPrices(variantExists, price, compareAtPrice) {
    var comparePrice = this.container.querySelector(selectors.comparePrice);
    var productPrice = this.container.querySelector(selectors.productPrice);
    var priceAmount = this.container.querySelector('[data-product-price-amount]');
    var priceWrapper = this.container.querySelector(selectors.priceWrapper); // No matching variant

    if (!variantExists) {
      if (comparePrice) {
        comparePrice.textContent = '';
        comparePrice.classList.add(cssClasses.hide);
      }
      if (priceWrapper) {
        priceWrapper.classList.remove(cssClasses.onsale);
      }
      return;
    } // Variant exists

    var formattedPrice = (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_19__.formatMoney)(price, theme.moneyFormat);

    if (priceAmount) {
      priceAmount.textContent = formattedPrice.replace(/<[^>]*>/g, '');
    } else if (productPrice) {
      productPrice.textContent = formattedPrice.replace(/<[^>]*>/g, '');
    }

    if (!comparePrice || !priceWrapper) {
      return;
    }

    if (price < compareAtPrice) {
      comparePrice.textContent = (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_19__.formatMoney)(compareAtPrice, theme.moneyFormat).replace(/<[^>]*>/g, '');
      priceWrapper.classList.add(cssClasses.onsale);
      comparePrice.classList.remove(cssClasses.hide);
    } else {
      comparePrice.textContent = '';
      priceWrapper.classList.remove(cssClasses.onsale);
      comparePrice.classList.add(cssClasses.hide);
    }
  },

  /**
   * Scrolls the image slider to that of the current variant
   *
   * @param {number} variantId - ID of the selected variant
   * @param {string} sliderImages - DOM selector for product image slider
   */
  updateFeaturedImage: function updateFeaturedImage(variantId, thisSlider) {
    var id = variantId ? variantId : this.container.dataset.firstVariant;
    var slider = thisSlider ? thisSlider : this.sliderDesktop;
    var sliderImages = this.container.querySelectorAll(selectors.productImageWrapper);

    if (sliderImages.length > 0) {
      for (var i = 0; i < sliderImages.length; i++) {
        var slide = sliderImages[i];
        var isVariantImage = slide.dataset.imageVariants.includes(id);

        if (isVariantImage && slider) {
          slider.select(Number(slide.dataset.slideIndex), this.sectionSettings.infinite, false);
          break;
        }
      }
    }
  },

  /**
   * Updates the DOM with the selected variant SKU
   *
   * @param {object} variant - Variant object
   */
  updateProductSku: function updateProductSku(variant) {
    if (!variant || !variant.sku) return;
    var skuElement = this.container.querySelector(selectors.productSku);
    if (!skuElement) return;
    skuElement.innerHTML = variant.sku;
  },

  /**
   * Updates the DOM with the selected variant inventory message
   *
   * @param {object} variant - Variant object
   */
  updateProductInventory: function updateProductInventory(variant) {
    if (!variant || !this.productInventories) return;
    var inventoryDetails = this.productInventories[variant.id];
    if (!inventoryDetails) return;
    var inventoryElement = this.container.querySelector(selectors.productInventory);
    if (!inventoryElement) return;
    var management = inventoryDetails.management,
        policy = inventoryDetails.policy,
        quantity = inventoryDetails.quantity;

    if (management !== 'shopify') {
      inventoryElement.innerHTML = '';
      return;
    }

    if (policy === 'continue' || quantity >= this.sectionSettings.inventory_low_stock_threshold) {
      inventoryElement.innerHTML = "".concat(_svg_icon_success_svg__WEBPACK_IMPORTED_MODULE_29__, " ").concat(window.theme.strings.inventory.inStock.replace('{{ count }}', quantity));
      return;
    }

    if (quantity > 0) {
      inventoryElement.innerHTML = "".concat(_svg_icon_alert_svg__WEBPACK_IMPORTED_MODULE_30__, " ").concat(window.theme.strings.inventory.lowStock.replace('{{ count }}', quantity));
      return;
    }

    inventoryElement.innerHTML = "".concat(_svg_icon_alert_svg__WEBPACK_IMPORTED_MODULE_30__, " ").concat(window.theme.strings.inventory.outOfStock);
  },

  /**
   * Initialises the read more link for product descriptions with more than one paragraph
   */
  initProductDescriptionMore: function initProductDescriptionMore() {
    var descriptionMoreLink = this.container.querySelector(selectors.productDescriptionMoreLink);
    var descriptionMoreContent = this.container.querySelector(selectors.productDescriptionMoreContent);
    if (!descriptionMoreLink || !descriptionMoreContent) return;
    descriptionMoreLink.addEventListener('click', function (event) {
      event.preventDefault();
      var moreContentIsHidden = descriptionMoreContent.classList.contains(cssClasses.hide);
      var moreLinkText = moreContentIsHidden ? window.theme.strings.product.description.readLess : window.theme.strings.product.description.readMore;
      descriptionMoreContent.classList.toggle(cssClasses.hide, !moreContentIsHidden);
      descriptionMoreLink.innerHTML = moreLinkText;
    });
  },

  /**
   * Initialises the product reviews slider
   */
  initReviewsSlider: function initReviewsSlider() {
    var reviewsSlider = this.container.querySelector(selectors.reviewsSlider);
    if (!reviewsSlider) return;
    this.reviewsSlider = new (flickity__WEBPACK_IMPORTED_MODULE_22___default())(reviewsSlider, {
      draggable: '>1',
      prevNextButtons: false,
      pageDots: true,
      watchCSS: true
    });
  },
  handleDownloadClick: function handleDownloadClick() {
    var downloadLinks = Array.from(this.container.querySelectorAll('.download-card__link'));
    downloadLinks.forEach(function (downloadLink) {
      var downloadIcon = downloadLink.previousElementSibling;
      downloadLink.addEventListener('click', function (event) {
        event.preventDefault();
        var downloadUrl = event.currentTarget.href;
        var filename = event.currentTarget.getAttribute('title');

        if (downloadIcon) {
          downloadIcon.classList.add('downloading');
        }

        fetch(downloadUrl, {
          method: 'GET'
        }).then(function (resp) {
          return resp.blob();
        }).then(function (blob) {
          var url = window.URL.createObjectURL(blob);
          var anchorElement = document.createElement('a');
          anchorElement.style.display = 'none';
          anchorElement.href = url;
          anchorElement.download = filename;
          document.body.appendChild(anchorElement);
          anchorElement.click();
          window.URL.revokeObjectURL(url);

          if (downloadIcon) {
            setTimeout(function () {
              downloadIcon.classList.remove('downloading');
            }, 3000);
          }
        })["catch"](function (error) {
          return window.console.error(error);
        });
      });
    });
  }
}));

/***/ }),

/***/ 249:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "playPause": () => (/* binding */ playPause)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(250);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1__);



/**
 * A small, dependency-free utility to play and pause YouTube and Vimeo
 * iFrame players without needing to load an external SDK.
 * @param {HTMLIFrameElement} video - YouTube or Vimeo player iFrame
 * @param {('play'|'pause')} action - `play` or `pause` the player
 */
var playPause = function playPause(video, action) {
  var _video$contentWindow, _video$src;

  if ((video === null || video === void 0 ? void 0 : video.tagName) !== 'IFRAME') return;
  if (!(video !== null && video !== void 0 && (_video$contentWindow = video.contentWindow) !== null && _video$contentWindow !== void 0 && _video$contentWindow.postMessage)) return;
  if (!(video !== null && video !== void 0 && (_video$src = video.src) !== null && _video$src !== void 0 && _video$src.match(/(youtube|vimeo)/))) return;
  if (action !== 'play' && action !== 'pause') return;

  var messageBuilder = function messageBuilder(src) {
    var videoType = src.match('youtube') ? 'youtube' : 'vimeo';
    var messageObject = videoType === 'youtube' ? {
      event: 'command',
      func: "".concat(action, "Video")
    } : {
      method: action
    };
    return JSON.stringify(messageObject);
  };

  var message = messageBuilder(video.src);
  video.contentWindow.postMessage(message, '*');
};

/***/ }),

/***/ 251:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "discountedProductPrice": () => (/* binding */ discountedProductPrice)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(230);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(231);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(252);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(179);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(253);
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_6__);








/**
 * Catalog / contextual price only.
 * Tag-based B2B pricing is retired.
 */
var discountedProductPrice = function discountedProductPrice(customerTags, productPrice) {
  return productPrice;
};

/***/ }),

/***/ 256:
/***/ ((module) => {

module.exports = "<svg aria-label=\"Alert icon\" class=\"icon icon-alert\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M10.0313 1C11.8113 1 13.5513 1.52782 15.0314 2.51675C16.5114 3.50569 17.665 4.91131 18.3462 6.55585C19.0274 8.20038 19.2056 10.01 18.8583 11.7558C18.5111 13.5016 17.6539 15.1053 16.3952 16.364C15.1365 17.6226 13.5329 18.4798 11.7871 18.8271C10.0412 19.1743 8.23164 18.9961 6.58711 18.3149C4.94257 17.6337 3.53698 16.4802 2.54805 15.0001C1.55911 13.5201 1.03126 11.78 1.03126 10C1.03126 7.61305 1.97948 5.32384 3.66731 3.63602C5.35514 1.94819 7.64431 1 10.0313 1ZM10.0313 0C8.05345 0 6.12006 0.586489 4.47557 1.6853C2.83108 2.78412 1.54934 4.3459 0.792462 6.17316C0.0355856 8.00042 -0.162451 10.0111 0.223401 11.9509C0.609253 13.8907 1.56166 15.6725 2.96019 17.071C4.35871 18.4696 6.14056 19.422 8.08037 19.8078C10.0202 20.1937 12.0308 19.9957 13.8581 19.2388C15.6854 18.4819 17.2471 17.2002 18.346 15.5557C19.4448 13.9112 20.0313 11.9778 20.0313 10C20.0313 7.34784 18.9777 4.80429 17.1023 2.92892C15.227 1.05356 12.6834 0 10.0313 0Z\" fill=\"currentColor\"/>\r\n<path d=\"M9.03125 4H10.9113V7.70996L10.4612 12.59H9.52124L9.03125 7.70996V4ZM9.03125 13.86H10.8712V15.78H9.03125V13.86Z\" fill=\"currentColor\"/>\r\n</svg>\r\n";

/***/ }),

/***/ 255:
/***/ ((module) => {

module.exports = "<svg aria-label=\"Success icon\" class=\"icon icon-success\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M10.0313 1C11.8113 1 13.5513 1.52782 15.0314 2.51675C16.5114 3.50569 17.665 4.91131 18.3462 6.55585C19.0274 8.20038 19.2056 10.01 18.8583 11.7558C18.5111 13.5016 17.6539 15.1053 16.3952 16.364C15.1365 17.6226 13.5329 18.4798 11.7871 18.8271C10.0412 19.1743 8.23164 18.9961 6.58711 18.3149C4.94257 17.6337 3.53698 16.4802 2.54805 15.0001C1.55911 13.5201 1.03126 11.78 1.03126 10C1.03126 7.61305 1.97948 5.32384 3.66731 3.63602C5.35514 1.94819 7.64431 1 10.0313 1ZM10.0313 0C8.05345 0 6.12006 0.586489 4.47557 1.6853C2.83108 2.78412 1.54934 4.3459 0.792462 6.17316C0.0355856 8.00042 -0.162451 10.0111 0.223401 11.9509C0.609253 13.8907 1.56166 15.6725 2.96019 17.071C4.35871 18.4696 6.14056 19.422 8.08037 19.8078C10.0202 20.1937 12.0308 19.9957 13.8581 19.2388C15.6854 18.4819 17.2471 17.2002 18.346 15.5557C19.4448 13.9112 20.0313 11.9778 20.0313 10C20.0313 7.34784 18.9777 4.80429 17.1023 2.92892C15.227 1.05356 12.6834 0 10.0313 0Z\" fill=\"currentColor\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.10156 10.6L8.10156 14.6L15.8016 6.6L14.7016 5.5L8.10156 12.4L5.30156 9.5L4.10156 10.6Z\" fill=\"currentColor\"/>\r\n</svg>\r\n";

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			27: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkbibendum"] = self["webpackChunkbibendum"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [37], () => (__webpack_require__(242)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;